import { Point } from 'pixi.js';

export const shakePositions = [
    new Point(2, 0),
    new Point(-2, 0),
    new Point(1.5, 0),
    new Point(-1.5, 0),
    new Point(1, 0),
    new Point(-1, 0),
    new Point(0.6, 0),
    new Point(-0.6, 0),
];
